<div class="promo-code">
  <form class="promo-code__form" [formGroup]="formGroup" (ngSubmit)="submit()">
    <app-form-input-group
      class="promo-code__form__input-group"
      [errors]="formGroup.get('promoCode').errors || promoCodeError"
      errorKey="promoCode"
      label="{{ 'checkout.payment.promocode.label' | translate }}"
    >
      <app-form-input
        [promoCodeStatus]="codeStatus"
        #content
        formControlName="promoCode"
        [disabled]="promoCodeIsDefined"
        type="text"
        [placeholder]="'checkout.payment.promocode.placeholder' | translate"
        [required]="false"
        autocomplete="off"
        (focusInput)="focusInput.emit()"
      >
      </app-form-input>
    </app-form-input-group>
    <button
      *ngIf="!promoCodeIsDefined"
      app-vtmn-play-button
      type="submit"
      [type]="ctaButtonType.Submit"
      [variant]="vtmnPlayButtonVariant.PRIMARY"
      class="promo-code__form__button"
      [disabled]="isButtonDisabled ? true : null"
      [attr.data-disabled]="isButtonDisabled ? true : null"
      [attr.data-loading]="isLoading ? true : null"
    >
      <output *ngIf="isLoading" aria-live="polite" data-part="loading-slot">
        <span
          id=":rk:"
          class="vp-spinner"
          aria-label="Loading..."
          data-part="loading-dots"
        >
          <span></span>
          <span></span>
          <span></span>
        </span>
      </output>
      <span [class.payment-button-text--loading]="isLoading">
        {{ 'checkout.payment.promocode.button' | translate }}
      </span>
    </button>
    <button
      *ngIf="promoCodeIsDefined"
      app-vtmn-play-button
      type="button"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      class="promo-code__form__button"
      (click)="showConfirmCodeDeletionModal()"
    >
      {{ 'checkout.promocode.button.delete' | translate }}
    </button>

    <app-modal
      #confirmCodeDeletionModal
      class="promo-code__form__modal"
      (modalClose)="closeConfirmCodeDeletionModal()"
    >
      <span modal-header class="promo-code__form__modal__title">
        {{ 'checkout.promocode.modal.delete.title' | translate }}
      </span>

      <div modal-content>
        <p>{{ 'checkout.promocode.modal.delete.text' | translate }}</p>
      </div>
      <div modal-footer class="promo-code__form__modal__footer">
        <button
          class="promo-code__form__modal__footer__confirm"
          app-vtmn-play-button
          type="button"
          [variant]="vtmnPlayButtonVariant.SECONDARY"
          [shape]="vtmnPlayButtonShape.SQUARED"
          (click)="closeConfirmCodeDeletionModal()"
        >
          {{ 'checkout.promocode.modal.delete.cancel' | translate }}
        </button>

        <button
          app-vtmn-play-button
          type="button"
          [variant]="vtmnPlayButtonVariant.PRIMARY"
          [shape]="vtmnPlayButtonShape.SQUARED"
          (click)="deletePromoCode()"
        >
          {{ 'checkout.promocode.modal.delete.confirm' | translate }}
        </button>
      </div>
    </app-modal>
  </form>
</div>
